import { IconAlcohol } from '@justeattakeaway/pie-icons-react';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import PIETag, { ETagsColorType } from '@src/shared/components/PIETag';
import React, { FC, ReactNode } from 'react';
import { globalStyles } from 'snacks-design-system';
import style from './TagAlcohol.module.scss';
import { useTranslation } from 'react-i18next';
const { xdsSpacingB } = globalStyles;

const TagAlcohol = () => {
  const { t } = useTranslation();
  return (
    <PIETag
      className={style.TagAlcohol}
      modStrong={true}
      mode={ETagsColorType.Brand}
    >
      <PIEComponentUtil paddingX={xdsSpacingB}>
        <IconAlcohol size="xs" /> {t('order.alcohol')}
      </PIEComponentUtil>
    </PIETag>
  );
};

export default TagAlcohol;
